var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.105h30v15.789H0V7.105Z",
    style: {
      fill: "#b22234"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,8.927h30M30,11.356H0M0,13.785h30M30,16.215H0M0,18.644h30M30,21.073H0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30,21.68H0v-1.215h30v1.215ZM30,19.251H0v-1.215h30v1.215ZM30,16.822H0v-1.215h30v1.215ZM30,14.393H0v-1.215h30v1.215ZM30,11.964H0v-1.215h30v1.215ZM30,9.534H0v-1.215h30v1.215Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.105h12v8.502H0V7.105Z",
    style: {
      fill: "#3c3b6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M1,7.47l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M1,9.17l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M1,10.87l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M1,12.571l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M1,14.271l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a5",
    "data-name": "a",
    d: "M2,8.32l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a6",
    "data-name": "a",
    d: "M2,10.02l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a7",
    "data-name": "a",
    d: "M2,11.721l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a8",
    "data-name": "a",
    d: "M2,13.421l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a9",
    "data-name": "a",
    d: "M3,7.47l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a10",
    "data-name": "a",
    d: "M3,9.17l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a11",
    "data-name": "a",
    d: "M3,10.87l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a12",
    "data-name": "a",
    d: "M3,12.571l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a13",
    "data-name": "a",
    d: "M3,14.271l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a14",
    "data-name": "a",
    d: "M4,8.32l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a15",
    "data-name": "a",
    d: "M4,10.02l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a16",
    "data-name": "a",
    d: "M4,11.721l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a17",
    "data-name": "a",
    d: "M4,13.421l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a18",
    "data-name": "a",
    d: "M5,7.47l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a19",
    "data-name": "a",
    d: "M5,9.17l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a20",
    "data-name": "a",
    d: "M5,10.87l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a21",
    "data-name": "a",
    d: "M5,12.571l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a22",
    "data-name": "a",
    d: "M5,14.271l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a23",
    "data-name": "a",
    d: "M6,8.32l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a24",
    "data-name": "a",
    d: "M6,10.02l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a25",
    "data-name": "a",
    d: "M6,11.721l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a26",
    "data-name": "a",
    d: "M6,13.421l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a27",
    "data-name": "a",
    d: "M7,7.47l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a28",
    "data-name": "a",
    d: "M7,9.17l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a29",
    "data-name": "a",
    d: "M7,10.87l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a30",
    "data-name": "a",
    d: "M7,12.571l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a31",
    "data-name": "a",
    d: "M7,14.271l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a32",
    "data-name": "a",
    d: "M8,8.32l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a33",
    "data-name": "a",
    d: "M8,10.02l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a34",
    "data-name": "a",
    d: "M8,11.721l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a35",
    "data-name": "a",
    d: "M8,13.421l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a36",
    "data-name": "a",
    d: "M9,7.47l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a37",
    "data-name": "a",
    d: "M9,9.17l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a38",
    "data-name": "a",
    d: "M9,10.87l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a39",
    "data-name": "a",
    d: "M9,12.571l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a40",
    "data-name": "a",
    d: "M9,14.271l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a41",
    "data-name": "a",
    d: "M10,8.32l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a42",
    "data-name": "a",
    d: "M10,10.02l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a43",
    "data-name": "a",
    d: "M10,11.721l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a44",
    "data-name": "a",
    d: "M10,13.421l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a45",
    "data-name": "a",
    d: "M11,7.47l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a46",
    "data-name": "a",
    d: "M11,9.17l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a47",
    "data-name": "a",
    d: "M11,10.87l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a48",
    "data-name": "a",
    d: "M11,12.571l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a49",
    "data-name": "a",
    d: "M11,14.271l.286.879-.748-.543h.924l-.748.543.286-.879Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUm);
export default __webpack_public_path__ + "static/media/UM.0816b8a22197bae71b7610bb159d3e6f.svg";
export { ForwardRef as ReactComponent };